import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const RegisterPageGetContentContext = React.createContext({});
export let registerPageGetContentMachine: any;

const MODULE_NAME = 'machines.registerPage.GetPageContent';

export const useSMRegisterPageGetContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  registerPageGetContentMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(registerPageGetContentMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    registerPageGetContentMachine,
    registerPageGetContentState: state,
    registerPageGetContentSend: send,
  };
};
